export default __webpack_public_path__ + "static/media/Yeongbin_Kim_Pict.3649687b.png";